import { Box, Typography } from "@mui/material";
import { Description } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

export interface SectionNotesProps {
  note: string;
}

export function SectionNotes({ note }: SectionNotesProps) {
  const { t } = useTranslation("singleCompanyComponent");
  const { colors: workspace } = useWorkspaceColors();
  return (
    <Box
      sx={{
        bgcolor: `${workspace.accent}0F`,
        borderRadius: 2,
        p: 2,
        border: `1px solid ${colors.gray200}`,
        borderLeft: `4px solid ${workspace.accent}`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Description
          sx={{
            color: workspace.accent,
            fontSize: "1.5rem",
            flexShrink: 0,
          }}
        />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            color: workspace.accent,
            textTransform: "uppercase",
            letterSpacing: 0.5,
            fontSize: "0.9rem",
          }}
        >
          {t("sectionNotes.title")}
        </Typography>
      </Box>
      <Box sx={{ ml: 4 }}>
        <Typography
          variant="body2"
          sx={{
            color: colors.gray700,
            lineHeight: 1.7,
            fontSize: "0.95rem",
            whiteSpace: "pre-line",
          }}
        >
          {note}
        </Typography>
      </Box>
    </Box>
  );
}
